import PrimerUpload from './PrimerUpload';
export default PrimerUpload;
